import { render, staticRenderFns } from "./Hazard.vue?vue&type=template&id=248b38f1&"
import script from "./Hazard.vue?vue&type=script&lang=js&"
export * from "./Hazard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports